import { create } from 'zustand';
import type {
  InstructionStatus,
  MonitoringFilters,
  SortField,
  SortOrder,
} from '@/features/monitoring/types';

// ---------------------------------------------------------------------------
// Monitoring filter store — Zustand
// ---------------------------------------------------------------------------

interface MonitoringStore extends MonitoringFilters {
  setStatus: (status: InstructionStatus) => void;
  setSearch: (search: string) => void;
  setDateFrom: (date: string) => void;
  setDateTo: (date: string) => void;
  setCurrency: (currency: string) => void;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  setSort: (field: SortField, order: SortOrder) => void;
  resetFilters: () => void;
  resetTenantScopedState: () => void;
}

const DEFAULT_FILTERS: MonitoringFilters = {
  status: 'all',
  search: '',
  date_from: '',
  date_to: '',
  currency: '',
  page: 1,
  limit: 20,
  sort_by: 'created_at',
  sort_order: 'desc',
};

export const useMonitoringStore = create<MonitoringStore>()((set) => ({
  ...DEFAULT_FILTERS,

  setStatus: (status) => set({ status, page: 1 }),
  setSearch: (search) => set({ search, page: 1 }),
  setDateFrom: (date_from) => set({ date_from, page: 1 }),
  setDateTo: (date_to) => set({ date_to, page: 1 }),
  setCurrency: (currency) => set({ currency, page: 1 }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),
  setSort: (field, order) => set({ sort_by: field, sort_order: order }),
  resetFilters: () => set(DEFAULT_FILTERS),
  // Filters reference tenant-scoped data (payment IDs, currencies seen on the
  // previous tenant), so they must be cleared on `cbs:tenant-switched`.
  resetTenantScopedState: () => set(DEFAULT_FILTERS),
}));
